import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import { catchError, from, Observable, of, switchMap, throwError } from 'rxjs';
import { isPlatformServer } from '@angular/common';
import { GrecaptchaService } from '../services/grecaptcha.service';
import { GRECAPTCHA_ACTION } from '../constants/GRECAPTCHA_ACTION';
import { environment } from '../../environments/environment';
import { UiService } from '@shared/services/ui.service';

@Injectable()
export class GRecaptchaInterceptor implements HttpInterceptor {
  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private _grecaptchaService: GrecaptchaService,
    private _uiService: UiService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (isPlatformServer(this.platformId)) {
      console.log('Skipping request due to SSR');
      return of();
    }

    const action = req.context.get(GRECAPTCHA_ACTION);

    if (!action || !environment.GRECAPTCHA_ENABLED) {
      return next.handle(req);
    }

    return from(this._grecaptchaService.execute(action)).pipe(
      catchError((err) => {
        this._uiService.setIsAppDisabled(true);
        console.error('reCAPTCHA failed', err);
        return throwError(() => err);
      }),
      switchMap((token) => {
        const apiReq = req.clone({
          setHeaders: {
            token: token,
          },
        });
        return next.handle(apiReq);
      })
    );
  }
}
